import { BorderRadius, Color, getDefaultTransition, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface SingleCardSelectCardWrapperProps {
  hasError?: boolean
  isSelected: boolean
}

const singleCardSelectCardWrapperSelectedStyle = css`
  border-color: ${Color.Black};
  cursor: default;

  &:hover {
    background-color: ${Color.White};
  }
`
const singleCardSelectCardWrapperErrorStyle = css`
  border-color: ${Color.Red700};
`

export const SingleCardSelectCardWrapper = styled.button<SingleCardSelectCardWrapperProps>`
  width: 100%;
  padding: ${Spacing.S14} ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R16};
  position: relative;
  text-align: left;
  cursor: pointer;
  ${getDefaultTransition('border-color')};

  &:hover {
    border-color: ${Color.Black};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  ${({ hasError }) => hasError && singleCardSelectCardWrapperErrorStyle};
  ${({ isSelected }) => isSelected && singleCardSelectCardWrapperSelectedStyle};
`
